<template lang="pug">
	vue-markdown.markdown-body(:source="source" :source-map="false" :id="elementId")
</template>

<script>
import VueMarkdown from 'vue-markdown-konishi'
import tippy, { inlinePositioning } from 'tippy.js'

export default {
	name      : 'MarkdownArticle',
	components: { VueMarkdown },
	props     : {
		source: String
	},
	data () {
		return {
			elementId: null
		}
	},
	mounted () {
		this.elementId = 'markdown-article-' + this._uid
		this.$nextTick(() => {
			const as = document.querySelectorAll('#' + this.elementId + ' a')
			if (as.length > 0) {
				as.forEach(element => element.addEventListener('click', this.clickAnchor))
			}

			const tips = document.querySelectorAll('#' + this.elementId + ' .huko-tip')
			if (tips.length > 0) {
				console.log(tips)
				tips.forEach(element => {
					tippy(element, {
						content: (reference) => {
							const text = reference.textContent.toLowerCase()
							switch (text) {
							case 'hukos or huks':
							case 'huko':
							case 'hukos':
								return this.tooltipTable('Huko', 'huko', '/ˈjuːko/')
							case 'theha':
								return this.tooltipTable('Theha', 'teha', '/ˈðɘjɑ/')
							case 'lafo':
								return this.tooltipTable('Lafo', 'lafo', '/ˈlɑfɒ/')
							case 'hodo':
							case 'hods':
								return this.tooltipTable('Hodo', 'hodo', '/ˈjoːdo/')
							case 'nehadora':
								return this.tooltipTable('Nehadora', 'nehadora', '/ˈŋɘjɑˈdɒɽɑ/')
							case 'kumo':
								return this.tooltipTable('Kumo', 'kumo', '/qɯˈɱɒ/')
							default:
								return null
							}
						},
						animation        : 'shift-away',
						theme            : 'light-border',
						appendTo         : 'parent',
						delay            : 400,
						inertia          : true,
						hideOnClick      : false,
						inlinePositioning: true,
						allowHTML        : true,
						plugins          : [inlinePositioning]
					})
				})
			}
		})
	},
	beforeDestroy () {
		const as = document.querySelectorAll('#' + this.elementId + ' a')
		if (as.length > 0) {
			as.forEach(element => element.removeEventListener('click', this.clickAnchor))
		}
	},
	methods: {
		tooltipTable (english, hukosh, pronounce) {
			return '<div class="huko-tip-table">' +
				'<div class="huko-english">' + english + '</div>' +
				'<div class="huko-script">' + hukosh + '</div>' +
				'<div class="huko-pronounce">' + pronounce + '</div>' +
				'</div>'
		},
		clickAnchor (e) {
			if (e.target.pathname.indexOf('/') === 0) {
				e.preventDefault()
				this.$router.push(e.target.pathname)
			}
		}
	}
}
</script>
